import { Component } from 'react';
import Calendar, { CalendarProps } from 'react-calendar';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { LOCALES_DOUBLE } from 'src/constants/main';
import Icon from 'src/view/components/Controls/Icon/Icon';
import './style.scss';

export default class ReactCalendar extends Component<CalendarProps, {}> {
  render() {
    return (
      <Calendar
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        calendarType={this.props.calendarType || 'Hebrew'}
        onClickDay={this.props.onClickDay || undefined}
        prevLabel={
          this.props.locale === LOCALES_DOUBLE.ar
            ? this.props.nextLabel || <Icon name={Icons.SliderRight} />
            : this.props.prevLabel || <Icon name={Icons.SliderLeft} />
        }
        nextLabel={
          this.props.locale === LOCALES_DOUBLE.ar
            ? this.props.prevLabel || <Icon name={Icons.SliderLeft} />
            : this.props.nextLabel || <Icon name={Icons.SliderRight} />
        }
        formatMonth={this.props.locale === LOCALES_DOUBLE.ar ? undefined : this.props.formatMonth}
        formatShortWeekday={this.props.locale === LOCALES_DOUBLE.ar ? undefined : this.props.formatShortWeekday}
        className={this.props.className}
      />
    );
  }
}
